import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useAbility } from '@features/authorization';
import { helpdeskSearchSchema, type HelpdeskSearch } from '@features/helpdesk';
import { SectionTabs } from '@shared/ui';

export function CrmKnowledgeNavigation({
  locale,
  active,
  search,
}: {
  locale: string;
  active: 'articles' | 'prompts' | 'instructions';
  search: HelpdeskSearch;
}) {
  const { t } = useTranslation();
  const ability = useAbility();
  const requestSearch = helpdeskSearchSchema.parse(search);
  return (
    <nav aria-label={t('aiContent.knowledge')}>
      <SectionTabs
        variant="secondary"
        activeId={active}
        items={[
          ...(ability.can('read', 'HelpdeskArticle')
            ? [{ id: 'articles', label: t('articles.title') }]
            : []),
          ...(ability.can('read', 'HelpdeskAiPrompt')
            ? [{ id: 'prompts', label: t('aiContent.prompts') }]
            : []),
          ...(ability.can('read', 'HelpdeskAiInstruction')
            ? [{ id: 'instructions', label: t('aiContent.instructions') }]
            : []),
        ]}
        renderLink={(item, { className }) => (
          <Link
            className={className}
            to={
              item.id === 'articles'
                ? '/$locale/crm/helpdesk/articles'
                : item.id === 'prompts'
                  ? '/$locale/crm/helpdesk/prompts'
                  : '/$locale/crm/helpdesk/instructions'
            }
            params={{ locale }}
            search={requestSearch}
          >
            {item.label}
          </Link>
        )}
      />
    </nav>
  );
}
